module.exports = __webpack_public_path__ + "src/img/galerie/innenrenovierung/Sport-Vorher.jpg";